<template>
  <div class="app-date-select">
		<label>{{label}}</label>
		<v-menu
			ref="menu"
			v-model="menu"
			:nudge-right="40"
			lazy
			transition="scale-transition"
			offset-y
			full-width
			max-width="290px"
			min-width="290px"
			:readonly="readonly"
			:disabled="readonly"
			class="date-picker-input"
		>
			<v-text-field
				slot="activator"
				:label="label"
				persistent-hint
				append-icon="event"
				solo
				:placeholder="placeHolder"
				:readonly="readonly"
				:disabled="readonly"
				:value="dateFormatted"
				class="text-field select-app"
			></v-text-field>
			<v-date-picker
				locale="es"
				:value="date"
				no-title
				:max="maxDate"
				:min="minDate"
				:readonly="readonly"
				:disabled="readonly"
				@input="sendDate"
			></v-date-picker>
		</v-menu>
	</div>
</template>

<script>
import { format } from 'date-fns';

function sendDate(date) {
	this.menu = false;
	const newDate = this.formatDate(date);
	const body = { value: newDate, model: this.model };
	this.$emit('input', body);
}

function formatDate(d) {
	if (!d) {
		return null;
	}
	const [year, month, day] = d.split('-');
	return `${month}/${day}/${year}`;
}

function parseDate(d) {
	if (!d) {
		return null;
	}
	return format(d, 'YYYY-MM-DD');
}

function dateFormatted(newValue) {
	this.date = this.parseDate(newValue);
}

function data() {
	return {
		date: '',
		menu: false,
	};
}

export default {
	name: 'app-date-select',
	data,
	props: {
		label: [String],
		readonly: {
			default: false,
			type: Boolean,
		},
		maxDate: [Date, String],
		minDate: {
			type: [Date, String],
		},
		model: {
			type: String,
		},
		placeHolder: {
			type: String,
		},
		dateFormatted: {
			type: [Date, String, Number],
		},
	},
	methods: {
		parseDate,
		formatDate,
		sendDate,
	},
	watch: {
		dateFormatted,
	},
};
</script>

<style lang="scss" scoped>
.text-field {
	border-radius: 3px;
	position: relative;
}

label {
	font-size: size(small);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-date-select.vue